import { render, staticRenderFns } from "./LinkNoFloat.vue?vue&type=template&id=6a0cd2b2&scoped=true"
import script from "./LinkNoFloat.vue?vue&type=script&lang=js"
export * from "./LinkNoFloat.vue?vue&type=script&lang=js"
import style0 from "./LinkNoFloat.vue?vue&type=style&index=0&id=6a0cd2b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0cd2b2",
  null
  
)

export default component.exports